export const environment = {
  production: false,
  envType: 'ESIGN',//STUDIO or ESIGN
  API_URL: `https://studioapi.dev.sdex.in`,
  // API_URL: `http://10.107.6.218:3544`,
  PRIVATE_KEY: 'XGgsQthLzMQvTo2hIXltdVt3O1JiPgi8',
};